export const setcurrentWorkspace = (value: any) => {
	return {
		type: 'SET_CURRENT_WORKSPACE',
		payload: value,
	};
};
